module.exports = __webpack_public_path__ + "img/gps-active.59214158.png";